// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M20 6L9 17l-5-5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M15 9l-6 6M9 9l6 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M12 9v4M12 16h.01%27/%3E%3Cpath d=%27M10.3 5.2L2.6 18.1A1.8 1.8 0 004.2 21h15.6a1.8 1.8 0 001.6-2.9L13.7 5.2a1.8 1.8 0 00-3.4 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279%27/%3E%3Cpath d=%27M12 11v5M12 8h.01%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container {
  top: 16px !important;
  right: 16px !important;
  width: min(360px, calc(100vw - 24px)) !important;
  padding: 0 !important;
  z-index: 99999 !important;
}

.notification {
  position: relative !important;
  width: 100% !important;
  min-height: 0 !important;
  margin: 0 0 10px !important;
  padding: 12px 14px 12px 50px !important;
  overflow: visible !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  background-color: #fff !important;
  background-image: none !important;
  color: #1e293b !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1) !important;
  font-family: Inter, "Public Sans", Roboto, Helvetica, Arial, sans-serif !important;
  line-height: 1.4 !important;
  opacity: 1 !important;
  cursor: pointer;
}

.notification:hover,
.notification:focus {
  opacity: 1 !important;
}

.notification:before,
.notification-info:before,
.notification-success:before,
.notification-warning:before,
.notification-error:before {
  content: "" !important;
  font-family: inherit !important;
  font-size: 0 !important;
  line-height: 0 !important;
  text-align: center;
  position: absolute;
  top: 12px;
  left: 12px;
  width: 26px !important;
  height: 26px !important;
  margin-top: 0 !important;
  border-radius: 7px;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 15px 15px !important;
}

.notification-success {
  background: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
}

.notification-success:before {
  background-color: #10b981 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.notification-error {
  background: #fef2f2 !important;
  border-color: #fecaca !important;
}

.notification-error:before {
  background-color: #ef4444 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.notification-warning {
  background: #fffbeb !important;
  border-color: #fde68a !important;
}

.notification-warning:before {
  background-color: #f59e0b !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}

.notification-info {
  background: #eff6ff !important;
  border-color: #bfdbfe !important;
}

.notification-info:before {
  background-color: #4d7cfe !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}

.notification .notification-message {
  margin: 0 !important;
  padding: 0 !important;
}

.notification .title {
  margin: 0 0 2px !important;
  padding: 0 !important;
  color: #0f172a !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.notification .message {
  margin: 0 !important;
  padding: 0 !important;
  color: #475569 !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.45 !important;
  word-break: break-word;
}

@media (max-width: 640px) {
  .notification-container {
    top: 12px !important;
    right: 12px !important;
    left: 12px !important;
    width: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/notification-theme.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gDAAgD;EAChD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,yBAAyB;EACzB,uDAAuD;EACvD,kFAAkF;EAClF,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;;EAKE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oEAA8P;AAChQ;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oEAAiQ;AACnQ;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oEAA2W;AAC7W;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oEAAmS;AACrS;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;EACxB;AACF","sourcesContent":[".notification-container {\n  top: 16px !important;\n  right: 16px !important;\n  width: min(360px, calc(100vw - 24px)) !important;\n  padding: 0 !important;\n  z-index: 99999 !important;\n}\n\n.notification {\n  position: relative !important;\n  width: 100% !important;\n  min-height: 0 !important;\n  margin: 0 0 10px !important;\n  padding: 12px 14px 12px 50px !important;\n  overflow: visible !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  background-color: #fff !important;\n  background-image: none !important;\n  color: #1e293b !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1) !important;\n  font-family: Inter, \"Public Sans\", Roboto, Helvetica, Arial, sans-serif !important;\n  line-height: 1.4 !important;\n  opacity: 1 !important;\n  cursor: pointer;\n}\n\n.notification:hover,\n.notification:focus {\n  opacity: 1 !important;\n}\n\n.notification:before,\n.notification-info:before,\n.notification-success:before,\n.notification-warning:before,\n.notification-error:before {\n  content: \"\" !important;\n  font-family: inherit !important;\n  font-size: 0 !important;\n  line-height: 0 !important;\n  text-align: center;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  width: 26px !important;\n  height: 26px !important;\n  margin-top: 0 !important;\n  border-radius: 7px;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-size: 15px 15px !important;\n}\n\n.notification-success {\n  background: #f0fdf4 !important;\n  border-color: #bbf7d0 !important;\n}\n\n.notification-success:before {\n  background-color: #10b981 !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E\") !important;\n}\n\n.notification-error {\n  background: #fef2f2 !important;\n  border-color: #fecaca !important;\n}\n\n.notification-error:before {\n  background-color: #ef4444 !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 9l-6 6M9 9l6 6'/%3E%3C/svg%3E\") !important;\n}\n\n.notification-warning {\n  background: #fffbeb !important;\n  border-color: #fde68a !important;\n}\n\n.notification-warning:before {\n  background-color: #f59e0b !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 9v4M12 16h.01'/%3E%3Cpath d='M10.3 5.2L2.6 18.1A1.8 1.8 0 004.2 21h15.6a1.8 1.8 0 001.6-2.9L13.7 5.2a1.8 1.8 0 00-3.4 0z'/%3E%3C/svg%3E\") !important;\n}\n\n.notification-info {\n  background: #eff6ff !important;\n  border-color: #bfdbfe !important;\n}\n\n.notification-info:before {\n  background-color: #4d7cfe !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M12 11v5M12 8h.01'/%3E%3C/svg%3E\") !important;\n}\n\n.notification .notification-message {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.notification .title {\n  margin: 0 0 2px !important;\n  padding: 0 !important;\n  color: #0f172a !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  line-height: 1.3 !important;\n  letter-spacing: 0 !important;\n  text-transform: none !important;\n}\n\n.notification .message {\n  margin: 0 !important;\n  padding: 0 !important;\n  color: #475569 !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.45 !important;\n  word-break: break-word;\n}\n\n@media (max-width: 640px) {\n  .notification-container {\n    top: 12px !important;\n    right: 12px !important;\n    left: 12px !important;\n    width: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
